import * as Yup from 'yup';

export const productRestrictionSchema = Yup.object().shape({
  description: Yup.string().required('Descrição é obrigatória.'),
  restrictiveText: Yup.string().required('Texto restritivo é obrigatório.'),
});